<template>
  <button
    class="hover:bg-black/5 active:bg-black/10 select-none p-2 rounded-lg cursor-pointer"
    :data-modal-open="props.id"
  >
    <ul class="flex gap-2 text-[10px] text-black pointer-events-none">
      <li class="flex flex-col gap-2 items-center justify-center">
        Fornecedor

        <div
          class="bg-white p-1 rounded pointer-events-auto"
          :data-tippy-content="status[0].label"
          :data-modal-open="props.id"
        >
          <v-icon
            :iconify="status[0].icon"
            :class="`text-${status[0].color}-500 text-base`"
          ></v-icon>
        </div>
      </li>

      <li class="flex flex-col gap-2 items-center justify-center">
        Diretoria

        <div
          class="bg-white p-1 rounded pointer-events-auto"
          :data-tippy-content="status[1].label"
          :data-modal-open="props.id"
        >
          <v-icon
            :iconify="status[1].icon"
            :class="`text-${status[1].color}-500 text-base`"
          ></v-icon>
        </div>
      </li>

      <!-- <li class="flex flex-col gap-2 items-center justify-center">
        Comercial

        <div
          class="bg-white p-1 rounded pointer-events-auto"
          :data-tippy-content="status[2].label"
          :data-modal-open="props.id"
        >
          <v-icon
            :iconify="status[2].icon"
            :class="`text-${status[2].color}-500 text-base`"
          ></v-icon>
        </div>
      </li> -->

      <li class="flex flex-col gap-2 items-center justify-center">
        Contábil

        <div
          class="bg-white p-1 rounded pointer-events-auto"
          :data-tippy-content="status[2].label"
          :data-modal-open="props.id"
        >
          <v-icon
            :iconify="status[2].icon"
            :class="`text-${status[2].color}-500 text-base`"
          ></v-icon>
        </div>
      </li>

      <li class="flex flex-col gap-2 items-center justify-center">
        Cadastro

        <div
          class="bg-white p-1 rounded pointer-events-auto"
          :data-tippy-content="status[3].label"
          :data-modal-open="props.id"
        >
          <v-icon
            :iconify="status[3].icon"
            :class="`text-${status[3].color}-500 text-base`"
          ></v-icon>
        </div>
      </li>
    </ul>
  </button>
</template>

<script setup>
  const props = defineProps({
    value: {
      default: ['Incompleto', 'Incompleto', 'Incompleto', 'Incompleto'],
      type: Array,
    },
    id: {
      type: Number,
    },
  });

  let status = props.value;
  props.value.forEach((element, i) => {
    switch (element) {
      case 'Incompleto':
        status[i] = {
          icon: 'bi:record',
          label: element,
          color: 'gray',
        };
        break;
      case 'Confirmado':
        status[i] = {
          icon: 'bi:check',
          label: element,
          color: 'blue',
        };
        break;
      case 'Negado':
        status[i] = {
          icon: 'bi:x',
          label: element,
          color: 'red',
        };
        break;
      case 'Enviado':
        status[i] = {
          icon: 'bi:check-all',
          label: element,
          color: 'green',
        };
        break;

      default:
        status[i] = 'record';
        break;
    }
  });
</script>

<style scoped lang="scss">
  ul {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 75%;
      left: 50%;
      transform: translateX(-50%);
      border-bottom: 1px solid rgb(0 0 0 / 10%);
      width: 83%;
    }

    li {
      z-index: 1;

      svg {
        pointer-events: none;
      }
    }
  }
</style>
